import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationFilterSize } from '../../../../@types/model/masterData/pumpingStation/filterSize';
import MasterDataPumpingStationFilterSizeFunctions from '../../../../store/masterData/pumpingStation/filterSize/functions';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';

interface IPumpingStationFilterSizeSelectorProps {
    value : number | null;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : number | null) => void;

    isLoading : boolean;
    filterSizes : Array<IPumpingStationFilterSize>;
}

interface IPumpingStationFilterSizeSelectorState { }

class PumpingStationFilterSizeSelectorComponent extends React.Component<IPumpingStationFilterSizeSelectorProps, IPumpingStationFilterSizeSelectorState> {
    constructor(props : IPumpingStationFilterSizeSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationFilterSizeFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ? parseFloat(value.value) : null);
    };

    private readonly getData = (state : IPumpingStationFilterSizeSelectorState, props : IPumpingStationFilterSizeSelectorProps) => props.filterSizes;
    private readonly getValue = (state : IPumpingStationFilterSizeSelectorState, props : IPumpingStationFilterSizeSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationFilterSizeSelectorState, props : IPumpingStationFilterSizeSelectorProps) => props.required;


    private readonly getFilterSizes = createSelector([
        this.getData,
    ], (filterSizes) => filterSizes.filter(x => x.isActive).map(x => x.size).sort((a, b) => a - b));

    private readonly getFilterSizesForDropdown = createSelector([ 
        this.getRequired, this.getFilterSizes, 
    ], (required, filterSizes) => {
        
        const dropdownData = lodash.map(filterSizes, (element) => ({ label: `${element}`, value: element.toString() }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getFilterSizes, 
    ], (value, required, filterSizes) => {
        if (value) {
            const filterSize = filterSizes.find(element => element === value);

            if (filterSize) {
                return { label: filterSize.toString(), value: filterSize.toString() };
            } else {
                return { label: value.toString(), value: value.toString() };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getFilterSizesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'filterSize'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Filter Size'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>  
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.filterSize.isLoading,
        filterSizes: state.masterData.pumpingStation.filterSize.filterSizes,
    };
};

const PumpingStationFilterSizeSelector = connect(
    mapStateToProps,
)(PumpingStationFilterSizeSelectorComponent);

export default PumpingStationFilterSizeSelector;